import "./i18n/i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { applyBrand } from "./utils/brand";

import { createRoot } from "react-dom/client";
console.log("Version: 1.0.0.20250915.0");

// Branding de la plataforma (colores, título, favicon, manifest) antes del
// primer render. La plataforma puede fijarse en runtime desde build/env.js.
applyBrand();
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
reportWebVitals();
